<PadelSearch class="search-element" 
    :label="t('search_user')" 
    :value="user"
    :options="options"
    @onEnterPressed="searchUsers($event)" 
    @onClosePressed="handleSearchClose()" 
    @valueClicked="searchValueSelected($event)" 
    @validate="onSearchValidate($event)" />